/* eslint no-eval: 0 */

import React from 'react';
import {_GPY} from '../../../env.js'

import TweenMax from "gsap/TweenMax";
import CSSPlugin from "gsap/CSSPlugin";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import TweenLite from "gsap/TweenLite";
import TimelineLite from "gsap/TimelineLite";

class Animator extends React.Component {

  constructor(props) {
    super(props);
  }

  animate (io,overlayConfig,onCompleteFunc = ()=>{} ) {

    var w = parseFloat( this.props.display.props.width);
    var h = parseFloat(this.props.display.props.height);

     // console.log(overlayConfig.transition,(""+overlayConfig.transition),w,h,io);
//   io?TweenMax.to("."+this.props.stateName, 5, {bezier:[{left:0, top:h}, {left:0, top:(h/3)}, {left:0, top:0}], autoAlpha: 1,ease:Power1.easeInOut}) :TweenMax.to("."+this.props.stateName, 5, {bezier:[{left:100, top:250}, {left:300, top:0}, {left:500, top:400}], autoAlpha: 0,ease:Power1.easeInOut});

    if(overlayConfig.transition === "slideSmallFromUp") {
      io?TweenMax.to("."+this.props.stateName, 0.5, { y:0, x:0, autoAlpha: 1,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.5, { y:-100, x:0,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "slideSmallFromDown") {
      io?TweenMax.to("."+this.props.stateName, 0.5, { y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.5, { y:100, x:0,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "fadeSlowInOut") {
      io?TweenMax.to("."+this.props.stateName, 1.5, { autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1.5, { autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "fadeFastInOut") {
      io?TweenMax.to("."+this.props.stateName, 0.4, { autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.4, { autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "slideSmallFromLeft") {
      io?TweenMax.to("."+this.props.stateName, 0.5, { y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.5, { y:0, x:-100,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "slideSmallFromRight") {
      io?TweenMax.to("."+this.props.stateName, 0.5, { y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.5, { y:0, x:100,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "rotation90") {
        io?TweenMax.to("."+this.props.stateName, 1, { rotationY:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {rotationY:90,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "rotation360AndScale") {
      io?TweenMax.to("."+this.props.stateName, 1, { rotationY:0,scale:1, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {rotationY:360, scale:0.1, autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromCenterCenter") {
      io?TweenMax.to("."+this.props.stateName, 1, { scale:1, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromTopCenter") {
      io?TweenMax.to("."+this.props.stateName, 1, { scale:1, y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, y: -(h/2), x:0, autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromTopLeft") {
        io?TweenMax.to("."+this.props.stateName, 1, { scale:1, y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, y: -(h/2), x:-(w/2), autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromTopRight") {
        io?TweenMax.to("."+this.props.stateName, 1, { scale:1, y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, y: -(h/2), x:w, autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromDownRight") {
        io?TweenMax.to("."+this.props.stateName, 1, { scale:1, y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, y: h, x:w, autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromDownLeft") {
        io?TweenMax.to("."+this.props.stateName, 1, { scale:1, y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, y: h, x:-(w/2), autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "scaleFromDownCenter") {
          io?TweenMax.to("."+this.props.stateName, 1, { scale:1, y:0, x:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {scale:0.1, y: h, x: 0, autoAlpha: 0 ,onComplete:onCompleteFunc});

   } else if(overlayConfig.transition === "blurFadeInOut") {
         if(io){
           var blurElement = {a:20,b:0};
           var applyBlur = () => {
               TweenMax.set(["."+this.props.stateName], {autoAlpha: blurElement.b, webkitFilter:"blur(" + blurElement.a + "px)",filter:"blur(" + blurElement.a + "px)"});
           };
           TweenMax.to(blurElement, 1.5, {a:0,b:1,onUpdate:applyBlur,onComplete:onCompleteFunc})
         } else {
           var blurElement = {a:0,b:1};
           var applyBlur = () => {
               TweenMax.set(["."+this.props.stateName], { autoAlpha: blurElement.b, webkitFilter:"blur(" + blurElement.a + "px)",filter:"blur(" + blurElement.a + "px)"});
           };
           TweenMax.to(blurElement, 1.5, {a:20,b:0,onUpdate:applyBlur,onComplete:onCompleteFunc});
         }
   } else if(overlayConfig.transition === "rotation15FromLeft") {
      io?TweenMax.to("."+this.props.stateName, 0.5, { rotation:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.5, {rotation:-15,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else if(overlayConfig.transition === "rotation15FromRight") {
       io?TweenMax.to("."+this.props.stateName, 0.5, { rotation:0, autoAlpha: 1 ,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 0.5, {rotation:15,  autoAlpha: 0 ,onComplete:onCompleteFunc});

    } else {
       io?TweenMax.to("."+this.props.stateName, 1, {autoAlpha:1,onComplete:onCompleteFunc}) : TweenMax.to("."+this.props.stateName, 1, {autoAlpha:0 ,onComplete:onCompleteFunc});
    }
  }
}
export default Animator;
